import { Icon } from "dash-ui";

import { Property } from "gql/generated.graphql";

type PropertyInfoWindowProps = {
  property: Property;
  idxFeedId?: string;
  branding?: { mainColor?: string; textColor?: string };
};

export function PropertyInfoWindow(props: PropertyInfoWindowProps) {
  const property = props.property;

  const resolveImageSrc = () => {
    const mainPropertyMediaFile =
      property.mainPropertyMediaFile?.files[0]?.thumbnailFileUrl;
    if (mainPropertyMediaFile) {
      return mainPropertyMediaFile;
    }
    const portfolioPropertyFirstMediaFile =
      property.slideshowMedia?.[0]?.files[0]?.thumbnailFileUrl;
    if (portfolioPropertyFirstMediaFile) {
      return portfolioPropertyFirstMediaFile;
    }
    return "";
  };

  const imageSrc = resolveImageSrc();

  const address = property.location?.address;
  const projectStatus = property.projectStatus
    ?.toLocaleLowerCase()
    .split("_")
    .join(" ");
  const startPrice = property.priceRange?.min
    ? (property.priceRange?.min / 1000000).toFixed(1)
    : 0;
  const endPrice = property.priceRange?.max
    ? (property.priceRange?.max / 1000000).toFixed(1)
    : 0;
  const startBathrooms = property.averageBathroomsNumberValue?.min || 0;
  const endBathrooms = property.averageBathroomsNumberValue?.max || 0;
  const startBedrooms = property.averageBedroomsNumberValue?.min || 0;
  const endBedrooms = property.averageBedroomsNumberValue?.max || 0;
  const mainColor = props.branding?.mainColor || "#0284c7";
  const textColor = props.branding?.textColor || "#1e293b";

  return (
    <div>
      <div
        className={`flex flex-col overflow-clip text-sm w-[300px] cursor-pointer bg-white p-2 rounded-lg`}
      >
        <div className="relative">
          <div className="absolute flex items-center gap-2 m-2">
            {projectStatus && (
              <div
                className="capitalize text-xs text-white rounded px-3 py-1 shrink-0 shadow"
                style={{ backgroundColor: mainColor }}
              >
                <p>{projectStatus}</p>
              </div>
            )}
            {property.isMarkedAsVerified && (
              <div
                className="text-xs text-white rounded px-3 py-1 shrink-0 shadow"
                style={{ backgroundColor: mainColor }}
              >
                <p>Developer Verified</p>
              </div>
            )}
          </div>
          <img
            src={imageSrc}
            className="h-[150px] w-full object-cover rounded-lg"
          />
        </div>
        <div className="flex flex-col mt-2 gap-1">
          <p className="text-lg font-bold truncate">{property.name}</p>
          <p className="flex items-center flex-wrap text-sm">
            <span className="flex mr-4">{`From $${startPrice}M`}</span>
            <span className="flex items-center mr-4 gap-1">
              <Icon size={20} name="bathroom" /> {startBathrooms} -{" "}
              {endBathrooms}
            </span>
            <span className="flex items-center gap-1">
              <Icon size={20} name="bedroom" /> {startBedrooms} - {endBedrooms}
            </span>
          </p>
          <p className="mt-1 text-xs text-neutral-600">{`${address?.street}, ${address?.city}, ${address?.state}, ${address?.zipCode}`}</p>
          {property.yearBuilt && (
            <p className="text-xs text-neutral-600">
              {`Completion in ${property.yearBuilt}`}.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
